// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2mqOw","subheader":"ReorderModal_subheader__2Y0Lq","listWrap":"ReorderModal_listWrap__28THu"};